import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

import { IExternalShare, IExternalShareAccessLogEntry } from './types';

export function useFileShare({ id }: { id: string | undefined }): {
  data:
    | { share: IExternalShare; accessLog: IExternalShareAccessLogEntry[] }
    | undefined;
  error: unknown;
  mutate: KeyedMutator<unknown>;
} {
  const { data, error, mutate } = useSWR<{
    share: IExternalShare;
    accessLog: IExternalShareAccessLogEntry[];
  }>(id ? `file-shares/${id}` : null, SWRFetcher({ method: 'GET' }));

  return { data, error, mutate };
}
